import React from "react";

import HmcConnectedDevicesChart from "../digital-infrastructure/charts/HmcConnectedDevicesChart"
import HmcMobileDataTrafficChart from "../digital-infrastructure/charts/HmcMobileDataTrafficChart";
import HmcCloudComputingChart from "../digital-infrastructure/charts/HmcCloudComputingChart";
import HmcGlobalMarketChart from "../digital-infrastructure/charts/HmcGlobalMarketChart";

const DiGrowthDrivers = () => {
  return (
    <section id="digital-infrastructure-growth-drivers">
      <div class="main-padding">
        <div class="main-margin">
          <h1 class="sub-header mb-12">
            Digital Infrastructure Growth Drivers
          </h1>
          <p className="mb-12">
            From wearable technology monitoring our vital signs to artificial
            intelligence optimizing crop yields, digital infrastructure is
            becoming increasingly vital as the world transitions to a more
            connected and data-driven future. Below are just a few of the trends
            that we believe create a foundation for long-term growth potential
            in the sector.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 lg:gap-28">
              <HmcConnectedDevicesChart />
              <HmcMobileDataTrafficChart />
              <HmcCloudComputingChart />
              <HmcGlobalMarketChart />
          </div>
          <p className="mt-12 text-lg">
            There is no guarantee that these trends will continue or that DIR
            will be able to take advantage of them. Continued growth is
            speculative and may not occur.
          </p>
        </div>
      </div>
    </section>
  );
};

export default DiGrowthDrivers;
